import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=3e02dcba&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=3e02dcba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e02dcba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e02dcba')) {
      api.createRecord('3e02dcba', component.options)
    } else {
      api.reload('3e02dcba', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=3e02dcba&scoped=true&", function () {
      api.rerender('3e02dcba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8FuLb7EL3yBka/JS/comp/CookieBox.vue"
export default component.exports